// extracted by mini-css-extract-plugin
module.exports = {"div":"NotFound_div__1fc3Q","h1":"NotFound_h1__2nYm8","parpadeo":"NotFound_parpadeo__2GmS6","h2":"NotFound_h2__1yXoN","button":"NotFound_button__2z05c"};